import { render, staticRenderFns } from "./GoodsinfoModal.vue?vue&type=template&id=3901dd6e&scoped=true&"
import script from "./GoodsinfoModal.vue?vue&type=script&lang=js&"
export * from "./GoodsinfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901dd6e",
  null
  
)

export default component.exports